import { getSubdomain } from 'tldjs';

const getHerokuReviewAppURL = subdomain => {
  return `https://${subdomain}.herokuapp.com`;
};

// Dynamically set the base API URL based on the current hostname
// This allows for using a Heroku review app URL as the base API URL (without DNS or Netlify changes).
// Staging Example: https://soraban-pr-2326.soraban.dev (front-end) will set the base API URL as https://soraban-pr-2326.herokuapp.com
// Netlify Deploy Preview Example: https://soraban-pr-123--soraban-dev.netlify.app (front-end) will set the base API URL as https://soraban-pr-123.herokuapp.com
function getApiBaseURL() {
  try {
    const { hostname, href } = window.location;
    const subdomain = getSubdomain(href);

    // The staging environment always uses the static
    // Heroku staging environment URL defined with `process.env.API_URL`
    if (subdomain === 'staging') return process.env.API_URL;

    // Hostnames off soraban.dev will use staging Netlify instance with a Heroku reivew app
    if (hostname.includes('soraban.dev')) {
      return getHerokuReviewAppURL(subdomain);
    }

    // Hostnames off netlify.app are Netlify deploy previews
    // Deploy previews that use a branch name matching the Heroku review app convention i.e. <soraban-pr-XXXX>
    // will route to that corresponding Heroku review app name
    if (hostname.includes('netlify.app') && subdomain.includes('soraban-pr')) {
      // Extract the Heroku review app subdomain
      // Ex. https://soraban-pr-123--soraban-dev.netlify.app
      const herokuSubdomain = hostname.split('--soraban-dev')[0];

      return getHerokuReviewAppURL(herokuSubdomain);
    }

    // Production and fallback cases
    return process.env.API_URL;
  } catch (error) {
    return process.env.API_URL;
  }
}

export { getApiBaseURL };
